
import mixpanel from 'mixpanel-browser';

const { token, cookieDomain, secureCookie, record, debug } = window.__MIXPANEL_CONFIG__;

mixpanel.init(token, {
  cross_subdomain_cookie: true,
  cookie_domain: cookieDomain,
  secure_cookie: secureCookie,
  debug: debug,
  ...(record ? {
    record_sessions_percent: 100,
    record_block_selector: '[data-record-block]',
    record_mask_text_selector: '[data-record-mask]',
    record_collect_fonts: true,
  } : {})
});

// Expose on window so other scripts (e.g. ocamaker-cookie.liquid) can call window.mixpanel.track()
window.mixpanel = mixpanel;

// Unified custom-event helper: one call fans out to every analytics tool.
//   trackEvent('cta_click', { location: 'hero' });
// For a single destination use window.mixpanel.track(...) or window.trackGAEvent(...).
// ALL page events must go through this helper — never call mixpanel.track()
// directly, or the event silently skips GA4.
window.trackEvent = (eventName, properties) => {
  mixpanel.track(eventName, properties || {});
  // Forward to GA4/Firebase. trackGAEvent is defined by firebase-analytics.liquid
  // (a no-op when analytics is disabled); checked lazily so load order is irrelevant.
  // GA4 only accepts event names matching [A-Za-z][A-Za-z0-9_]* (max 40 chars) —
  // names with spaces (e.g. 'Link Clicked') are flagged invalid and can't be
  // marked as key events, so sanitize for the GA4 leg only. Case is preserved
  // so existing GA4 events (e.g. 'startedQuiz') keep their exact name.
  if (typeof window.trackGAEvent === 'function') {
    const gaEventName = eventName
      .trim()
      .replace(/[^A-Za-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 40);
    window.trackGAEvent(gaEventName, properties || {});
  }
};

// Mixpanel-only on purpose: GA4 already auto-collects page_view when Firebase
// Analytics initializes, so fanning this out would double-count GA4 page views.
mixpanel.track('Page View', {
  page_title: document.title,
  page_url: window.location.href,
  page_path: window.location.pathname,
  referrer: document.referrer,
});

document.querySelectorAll('a[href]').forEach(link => {
  link.addEventListener('click', function() {
    const href = this.getAttribute('href');
    window.trackEvent('Link Clicked', {
      link_text: this.textContent.trim(),
      link_url: href,
      link_type: href.startsWith('http') ? 'external' : 'internal',
      page_url: window.location.href,
    });
  });
});

document.querySelectorAll('button, [role="button"]').forEach(button => {
  button.addEventListener('click', function() {
    window.trackEvent('Button Clicked', {
      button_text: this.textContent.trim(),
      button_class: this.className,
      page_url: window.location.href,
    });
  });
});

document.querySelectorAll('form').forEach(form => {
  form.addEventListener('submit', function() {
    window.trackEvent('Form Submitted', {
      form_id: this.id || 'unnamed_form',
      page_url: window.location.href,
    });
  });
});
